import React from "react";

const WTF360ConsultationNotes = ({ rowData, closeModal }) => {
  return (
    <div className="wtf-360-consultation-notes-container mt30">
      <div className="wtf-360-consultation-notes-section">
        <h3 className="wtf-360-consultation-notes-section-title">
          Customer Details
        </h3>
        <div className="wtf-360-consultation-notes-info">
          <div className="wtf-360-consultation-notes-info-item">
            <span className="wtf-360-consultation-notes-info-label">Name:</span>
            <span className="wtf-360-consultation-notes-info-value">
              {rowData?.full_name || "N/A"}
            </span>
          </div>
          <div className="wtf-360-consultation-notes-info-item">
            <span className="wtf-360-consultation-notes-info-label">Phone:</span>
            <span className="wtf-360-consultation-notes-info-value">
              {rowData?.phone_number || "N/A"}
            </span>
          </div>
        </div>
      </div>

      <div className="wtf-360-consultation-notes-section">
        <h3 className="wtf-360-consultation-notes-section-title">Notes</h3>
        <div className="wtf-360-consultation-notes-content-box">
          <p className="wtf-360-consultation-notes-content-text">
            {rowData?.notes || "No notes available"}
          </p>
        </div>
      </div>

      <div className="wtf-360-consultation-notes-actions">
        <button
          className="wtf-360-consultation-notes-action-btn wtf-360-consultation-notes-action-btn-close"
          onClick={closeModal}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default WTF360ConsultationNotes;
